import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "types";
import { initialState } from "./initialState";

const selectDomain = (state: RootState) =>
  state.hydraulicWallState || initialState;

export const selectHydraulicWallLoading = createSelector(
  [selectDomain],
  (hydraulicWallState) => hydraulicWallState.loading
);

export const selectHydraulicWallList = createSelector(
  [selectDomain],
  (hydraulicWallState) => hydraulicWallState.list
);

export const selectHydraulicWallMeta = createSelector(
  [selectDomain],
  (hydraulicWallState) => hydraulicWallState.meta
);

export const selectHydraulicWallPage = createSelector(
  [selectDomain],
  (hydraulicWallState) => hydraulicWallState.page
);

export const selectHydraulicWallPerPage = createSelector(
  [selectDomain],
  (hydraulicWallState) => hydraulicWallState.perPage
);

export const selectIsAddModalOpen = createSelector(
  [selectDomain],
  (hydraulicWallState) => hydraulicWallState.isAddModalOpen
);

export const selectHydraulicWallForm = createSelector(
  [selectDomain],
  (hydraulicWallState) => hydraulicWallState.form
);

export const selectHydraulicWallSaving = createSelector(
  [selectDomain],
  (hydraulicWallState) => hydraulicWallState.saving
);
